export const getCurrencyFormat = (format, digits) => {
  switch (format) {
    case '1,200.50':
    case '12.50':
      return {
        decimalDigits: digits,
        decimalSymbol: '.',
        thousandSymbol: ',',
        prefix: '',
        suffix: '',
      }
    case '12,50':
    case '1.200,50':
      return {
        decimalDigits: digits,
        decimalSymbol: ',',
        thousandSymbol: '.',
        prefix: '',
        suffix: '',
      }
    case '1 200.50':
      return {
        decimalDigits: digits,
        decimalSymbol: '.',
        thousandSymbol: ' ',
        prefix: '',
        suffix: '',
      }
    case '1 200,50':
      return {
        decimalDigits: digits,
        decimalSymbol: ',',
        thousandSymbol: ' ',
        prefix: '',
        suffix: '',
      }
    case '12.5':
    case '1,200.5':
      return {
        decimalDigits: 1,
        decimalSymbol: '.',
        thousandSymbol: ',',
        prefix: '',
        suffix: '',
      }
    case '12,5':
    case '1.200,5':
      return {
        decimalDigits: 1,
        decimalSymbol: ',',
        thousandSymbol: '.',
        prefix: '',
        suffix: '',
      }
    case '12':
    case '1,200':
      return {
        decimalDigits: 0,
        decimalSymbol: '.',
        thousandSymbol: ',',
        prefix: '',
        suffix: '',
      }
    case '1.200':
      return {
        decimalDigits: 0,
        decimalSymbol: ',',
        thousandSymbol: '.',
        prefix: '',
        suffix: '',
      }
    case '1,200.500':
    case '12.500':
      return {
        decimalDigits: 3,
        decimalSymbol: '.',
        thousandSymbol: ',',
        prefix: '',
        suffix: '',
      }
    case '12,500':
    case '1.200,500':
      return {
        decimalDigits: 3,
        decimalSymbol: ',',
        thousandSymbol: '.',
        prefix: '',
        suffix: '',
      }
    default:
      return {
        decimalDigits: 2,
        decimalSymbol: '.',
        thousandSymbol: ',',
        prefix: '',
        suffix: '',
      }
  }
}

export const singleNumberFormat = function (input = '', format) {
  let number = parseFloat(input)
  if (isNaN(number)) {
    number = 0
  }

  if (!format) {
    return input
  }
  let str = format.prefix || ''
  let decimals = parseInt(format.decimalDigits)

  if (decimals == 0 || isNaN(decimals)) {
    str += String(number.toFixed(0)).replace(/\B(?=(?:\d{3})+(?!\d))/g, '$&' + format.thousandSymbol)
  } else {
    str += String(number.toFixed(decimals))
      .replace(/\d(?=(\d{3})+\.)/g, '$&' + format.thousandSymbol)
      .replace('.', format.decimalSymbol)
  }
  if (format.suffix) {
    str += format.suffix
  }

  return str
}
